import {ArrowRightIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {type PropsWithChildren, useCallback, useRef, useState} from 'react'

import {LABELS} from '../../../constants/labels'
import {RelationshipsListAllModal} from './RelationshipsListAllModal'
import styles from './RelationshipsViewAllButton.module.css'

export type RelationshipsViewAllButtonProps = PropsWithChildren<{
  dialogTitle: string
  count: number
}>

export function RelationshipsViewAllButton({dialogTitle, count, children}: RelationshipsViewAllButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const linkItemRef = useRef<HTMLLIElement>(null)
  const onDialogClose = useCallback(() => setIsDialogOpen(false), [])

  return (
    <>
      <ActionList.Item onSelect={() => setIsDialogOpen(!isDialogOpen)} ref={linkItemRef}>
        <ActionList.LeadingVisual>
          <div className={styles.RelationshipsViewAllButton_LeadingSpacer} />
        </ActionList.LeadingVisual>

        <span className={styles.RelationshipsViewAllButton_Label}>
          {LABELS.relationViewAll} <ArrowRightIcon />
        </span>
      </ActionList.Item>

      {isDialogOpen && (
        <RelationshipsListAllModal dialogTitle={dialogTitle} count={count} onClose={onDialogClose}>
          {children}
        </RelationshipsListAllModal>
      )}
    </>
  )
}
